import { jsx } from "@emotion/react/jsx-runtime";
import i18n from "i18next";
import ICU from "i18next-icu";
import { useState, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import resources from "./resources.generated.js";
const DEFAULT_LANGUAGE = "en-US";
function findFallbackLng(code) {
  switch (code) {
    case "pt":
      return "pt-BR";
    case "de":
      return "de-DE";
    case "es":
      return "es-ES";
    case "en":
      return "en-US";
    default:
      return DEFAULT_LANGUAGE;
  }
}
const I18nProvider = ({
  children,
  language,
  onError
}) => {
  const [i18nInstance, setInstance] = useState(null);
  useEffect(() => {
    const lng = language != null ? language : DEFAULT_LANGUAGE;
    const instance = i18n.createInstance({
      fallbackLng: findFallbackLng,
      interpolation: {
        escapeValue: false
      },
      lng,
      resources,
      returnNull: false
    }, (err) => {
      if (err) {
        onError == null ? void 0 : onError(err);
      }
    }).use(ICU);
    instance.init().then(() => {
      setInstance(instance);
    });
  }, [language, onError]);
  if (i18nInstance == null) {
    return null;
  }
  return /* @__PURE__ */ jsx(I18nextProvider, { i18n: i18nInstance, children });
};
export {
  DEFAULT_LANGUAGE,
  I18nProvider,
  findFallbackLng
};
